const dataTableData = {
  columns: [
    { Header: "#", accessor: "#", width: "5%" },
    // { Header: "ID", accessor: "id", width: "5%" },

    { Header: "الاسم", accessor: "name", width: "15%" },
    // { Header: "الوصف", accessor: "description", width: "25%" },
    { Header: " العميل", accessor: "clientName", width: "15%" },
    { Header: "المزانية", accessor: "budget", width: "100%" },
    // { Header: "الميزانية الفعلية", accessor: "actualExpenditure", width: "100%" },
    { Header: "تاريخ البدأ", accessor: "startedDate", width: "10%" },
    { Header: "تاريخ الانتهاء", accessor: "endedDate", width: "10%" },
    // { Header: " التصنيف", accessor: "categoryName", width: "10%" },
    { Header: " الحالة", accessor: "projectStatusName", width: "100%" },
    { Header: "نسبة الانجاز", accessor: "progress", width: "5%" },
    // { Header: "عدد طلبات التغيير", accessor: "changeRequestCount", width: "10%" },
    // { Header: "الصورة", accessor: "imageUrl", width: "15%" },
    // { Header: "مدراء المشروع", accessor: "projectManager", width: "20%" },
    { Header: "اجراء", accessor: "actions", width: "10%" },
  ],

  rows: [], // Populate this with data from your API or DTOs as required
};

export default dataTableData;
